"use strict";

function sendEventShopajInViewport(isMob, shopaj24Widget) {
  if (isMob) {
    if (window.isInViewport(shopaj24Widget)) {
      window.googleSendEvent('FixPlacement6', 'Viewable', 'Feed');
    } else {
      const controller = new AbortController();
      window.addEventListener('scroll', window.debounce(() => {
        if (window.isInViewport(shopaj24Widget)) {
          window.googleSendEvent('FixPlacement6', 'Viewable', 'Feed');
          controller.abort();
        }
      }, 10), {
        passive: true,
        signal: controller.signal
      });
    }
  }
}
function shopaj24Widgets() {
  const shopaj24Widgets = document.querySelectorAll('.js_shopaj24');
  const {
    isMob
  } = window;
  shopaj24Widgets.forEach(widget => {
    if (widget.src) return;
    let widgetCode = widget.dataset.code;

    // this is a hack for article feed because we don't have separate feed
    // templates for mobile / desktop so we hardcode desktop placeholder code
    if (widgetCode === 'shopaj24_widget_mobile_article_url' && !isMob) {
      widgetCode = 'shopaj24_widget_desktop_homepage_url_2';
    }
    const shopaj24Url = window.getSettingsFromApi(widgetCode);
    widget.setAttribute('src', shopaj24Url);
    window.iFrameResize({
      checkOrigin: false
    }, widget);
    widget.parentElement?.setAttribute('style', 'display: block;');
    sendEventShopajInViewport(isMob, widget);
  });
}
if (window.apiSettings) {
  shopaj24Widgets();
} else {
  document.addEventListener("FeedInitialized", () => {
    window.apiSettings ? shopaj24Widgets() : document.addEventListener("BaseDataLoaded", shopaj24Widgets);
  });
}